export enum SourceVideoType {
    WEBCAM = 'WEBCAM',
    SCREENCAST = 'SCREENCAST',
    VIRTUAL_SCREENCAST = 'VIRTUAL_SCREENCAST',
    UPLOAD = 'UPLOAD',
    AI_AVATAR='AI_AVATAR',
    NONE = 'NONE',
}
